
export const create_basic_auth = (username, password) => {
    const base64Credentials = btoa(`${username}:${password}`)
    return `Basic ${base64Credentials}`
}
 